module.exports = __webpack_public_path__ + "static/media/icon_books.6ceb3671.svg";